import { getDomainUrl } from 'core/utils';

export const oldAdminGeneralSettingsPath = () => `${getDomainUrl()}/company/settings`;

export const oldAdminSettingsPath = () => `${getDomainUrl()}/company/settings`;

export const oldAdminSetUpPath = () => `${getDomainUrl()}/company/settings`;

export const oldAdminFormattingColorsPath = () => `${getDomainUrl()}/company/settings`;
export const oldAdminFormattingFontsPath = () => `${getDomainUrl()}/company/settings`;
export const oldAdminFormattingLogosPath = () => `${getDomainUrl()}/company/settings`;

export const oldAdminUsersPath = () => `${getDomainUrl()}/company/users`;

export const oldAdminLocationsPath = () => `${getDomainUrl()}/company/locations`;

export const oldAdminRolesPath = () => `${getDomainUrl()}/company/roles`;

export const oldAdminLaborRatesPath = () => `${getDomainUrl()}/company/settings`;

export const oldAdminSupportRequestsPath = () => '/support/request/list';

export const oldAdminPartsPath = () => `${getDomainUrl()}/company/parts`;
export const oldAdminExternalPartsPath = () => `${getDomainUrl()}/company/external-parts`;

//Import/Export routes
export const oldAdminInventoryLogPath = () => `${getDomainUrl()}/company/import-export`;
export const oldAdminInventoryFieldMappingPath = () => `${getDomainUrl()}/company/import-export`;
export const oldAdminManufacturerAliasesPath = () => `${getDomainUrl()}/company/import-export`;
export const oldAdminQuoteExportMappingPath = () => `${getDomainUrl()}/company/import-export`;
export const oldAdminJobExportFieldMappingPath = () => `${getDomainUrl()}/company/import-export`;
export const companyImportExportApprovedVendorsPath = () =>
  '/company/import-export/approved-vendors';
export const companyImportExportExtractorVendorMappingPath = () =>
  '/company/import-export/extractor-vendor-mapping';
export const companyImportExportUomConversionAuditPath = () =>
  '/company/import-export/uom-conversion-audit';

export const companyImportExportPathPattern = () => '/company/import-export/*';
export const companyPartFinderPathPattern = () => '/company/part-finder/*';

export const oldAdminIntegrationsPath = () => `${getDomainUrl()}/company/integrations`;

export const oldAdminEmailTemplatesPath = () => `${getDomainUrl()}/company/email-templates`;

export const partFinderAttributeListPath = () => '/company/part-finder/attribute/list';

export const partFinderFamilyListPath = () => '/company/part-finder/family/list';

export const partFinderFamilyPath = (id: number | string = ':id') =>
  `/company/part-finder/family/${id}`;

export const partFinderProductTypeListPath = () => '/company/part-finder/product-type/list';
